export enum FinancingPurpose {
  ACQUISITION,
  NEW_DEVELOPMENT,
  REDEVELOPMENT,
  REFINANCE,
}
